<template>
  <div>
    <dialogos-app :dialogos="dialogos"></dialogos-app>
    <v-layout>
      <v-flex text-xs-center>
        <SvgButtons @openModal="modal=true, text=$event, $set(vistos,$event,true)"/>
      </v-flex>
    </v-layout>
    <modal-app v-model="modal" :fullscreen="false" width="700px">
      <h1 class="modal-title">{{modalTitle}}</h1>
      <p>{{modalText}}</p>
    </modal-app>
    
    <audio-player ref="audioPlayer" :autoplay="true" :audios="[
    'Modulo 2/AUDIO 05'
    ]"></audio-player> 
  </div>  
</template>

<script>
import SvgButtons from '../../assets/Modulo 2/diapositiva-8'
export default {
  components:{
    SvgButtons
  },
  data() {
    return {
      dialogos: [
        "Si unimos el petróleo inicialmente en sitio y el proceso de producción obtendremos el siguiente esquema. Un análisis de esta clasificación nos indica lo siguiente. <span class='instruccion'>Haz clic en los dos iconos que se destacan.</span>" 
      ],
      text: 0,
      modal: false,
      vistos: Array(2).fill(false)
    }
  },
  created() {
    this.$store.commit('nextShow', false)
  },
  computed: {
    modalTitle: function(){
      switch(this.text){
        case 0: return 'Rango de incertidumbre'
        case 1: return 'Oportunidad de comercialización'
      }
      return ''
    },
    modalText: function(){
      switch(this.text){
        case 0: return 'Refleja un rango de cantidades estimadas potencialmente recuperables de una acumulación en un proyecto; como puedes observar en las reservas, el rango de incertidumbre es menor en las probadas que en las posibles, es decir; hay mayor certeza de recuperación en las reservas probadas.'
        case 1: return 'Es la oportunidad de que el proyecto se desarrolle y llegue a un estado de producción comercial. Observando la gráfica, es claro que hay una mayor oportunidad de comercialización en el rango de las reservas que en el de los recursos contingentes y mucho menor aún en el de los recursos prospectivos.'
      }
      return ''
    }
  },
  watch: {
    vistos: function(newValue){
      var todosVistos = newValue.every(el => {return el})
      if(todosVistos){
        this.$store.commit('nextShow', true)    
      }
    }
  }
}
</script>
<style lang="scss" scoped>
</style>
